import { FC } from "react";
import { Container } from "./styles";
import { Checkbox, ConfigProvider } from "antd";
import { Icon, IconName } from "Components/UI";
import { useSelector } from "react-redux";
import { getTheme } from "Store/MultiDomain/MultiDomain.selector";
import Tooltip from "Components/UI/Tooltip";

interface IItemDiscipline {
  name: string;
  icon?: IconName;
  checked?: boolean;
  loading?: boolean;
  disabled?: boolean;
  tooltipText?: string;
  onCheck: () => void;
}

const ItemDiscipline: FC<IItemDiscipline> = ({
  name,
  icon,
  checked,
  loading,
  disabled,
  tooltipText,
  onCheck,
}) => {
  const theme = useSelector(getTheme);

  return (
    <ConfigProvider theme={{
      token: {
        colorBgContainerDisabled: loading ? theme.colors.surface.surfaceOutline : `color-mix(in srgb, ${theme.colors.primary.primaryOutline}, ${theme.colors.surface.surface})`,
        colorTextDisabled: theme.colors.primary.onPrimary,
        colorPrimary: theme.colors.primary.primary
      }
    }}>
      <Container
        isloading={loading}
        onClick={(!loading && !disabled) ? onCheck : undefined}
      >
        <Tooltip
          placement="top"
          title={(disabled && !!tooltipText) ? tooltipText : ''}
        >
          <Checkbox checked={checked} disabled={disabled || loading} />
        </Tooltip>
        <Icon icon={icon || 'menuContexto'} customSize={16} className="icon" />
        <span className="disciplinaTitle">{name}</span>
      </Container>
    </ConfigProvider>
  )
}

export default ItemDiscipline;
